import { LoadMoreSectionProps } from './types';
import { doneListingLabel, loadingLabel, loadMoreLabel } from './constants';

const LoadMoreSection = ({
  done,
  loading,
  onLoadMore,
  refCallback,
}: LoadMoreSectionProps) => {
  return (
    <div className="scrollForMore" ref={refCallback} data-testid="load-more-section">
      {done ? (
        <h2 data-testid="done-loading">{doneListingLabel}</h2>
      ) : (
        <button
          className="hollowButton"
          onClick={onLoadMore}
          data-testid="load-more-button"
        >
          {loading ? loadingLabel : loadMoreLabel}
        </button>
      )}
    </div>
  );
};

export default LoadMoreSection;
